import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'app-one-line-card',
  templateUrl: './one-line-card.component.html',
  styleUrls: ['./one-line-card.component.scss'],
})
export class OneLineCardComponent {
  @Input() title: string;
  @Input() showIcon: true;
  @Output() editButtonEvent: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('icon') icon: any;
  public iconRef: any;

  emitEvent() {
    if (this.icon) {
      this.icon.el.click();
    }
  }

  setIconRef(event) {
    this.iconRef = event;
    if (!event.isTrusted) {
      this.editButtonEvent.emit(this.iconRef);
    }
  }
}
